var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"obi-logo"},[_c('ObiImage',{attrs:{"src":_vm.tenant.landing.logo.src}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }